"use strict";
import axios from "axios";
import { getAuthTokens } from "./cookieUtils";

const endpoint = process.env.REACT_APP_REST_ENDPOINT;
const apikey = process.env.REACT_APP_REST_APIKEY;


export const checkEmail = async (email) => {
  let data = JSON.stringify({
    email: email,
  });

  const options = {
    method: "POST",
    url: endpoint + "auth/checkemail",
    headers: {
   //   "x-api-key": apikey,
      "Content-Type": "application/json",
    },
    data: data,
  };

  let response = { available: false };

  try {
    const res = await axios.request(options);
    response = res.data;
  } catch (error) {
    response.error = true;
    console.error(error);
  }

  return response;
};

export const verify = async (user, code) => {
  let data = JSON.stringify({
    user: user,
    code: code,
  });

  const options = {
    method: "POST",
    url: endpoint + "auth/verify",
    headers: {
      // "x-api-key": apikey,
      "Content-Type": "application/json",
    },
    data: data,
  };

  let response = { success: false };

  try {
    const res = await axios.request(options);
    response = res.data;
  } catch (error) {
    response.error = true;
    console.error(error);
  }

  return response;
};

export const forgotPassword = async (email) => {
  let data = JSON.stringify({
    email: email,
  });

  const options = {
    method: "POST",
    // url: "https://pfmahqr4ik.execute-api.us-east-1.amazonaws.com/prod/forgot",
    url: endpoint + "auth/forgot",
    headers: {
      // "x-api-key": apikey,
      "Content-Type": "application/json",
    },
    data: data,
  };

  let response = { success: false, data: "" };

  try {
    const res = await axios.request(options);

    if (res.data.success) {
      response = { success: true, data: res.data };
    } else {
      response = { success: false, data: res.data.message };
    }
  } catch (error) {
    response = { success: false, data: error?.response?.data?.message || error?.message || "Unknown error" };
    console.error(error);
  }

  return response;
};

export const changePassword = async (
  email,
  token,
  oldPassword,
  newPassword
) => {
  let data = JSON.stringify({
    user: email,
    token: token,
    oldpassword: oldPassword,
    newpassword: newPassword,
  });

  const options = {
    method: "POST",
    url: endpoint + "auth/password",
    headers: {
      // "x-api-key": apikey,
      "Content-Type": "application/json",
    },
    data: data,
  };

  let response = { success: false };

  try {
    const res = await axios.request(options);
    response = res.data;
  } catch (error) {
    response.error = true;
    console.error(error);
  }

  return response;
};

export const resetPassword = async (email, code, confirmPassword) => {
  let data = JSON.stringify({
    user: email,
    confirmationCode: code,
    newPassword: confirmPassword,
  });

  const options = {
    method: "POST",
    url: endpoint + "auth/reset",
    headers: {
      // "x-api-key": apikey,
      "Content-Type": "application/json",
    },
    data: data,
  };

  let response = { success: false };

  try {
    const res = await axios.request(options);
    response = res.data;
  } catch (error) {
    response.error = true;
    console.error(error);
  }

  return response;
};

export const logoutSession = async (refreshToken) => {
  if (!refreshToken) {
    return { success: true, skipped: true };
  }

  const options = {
    method: "POST",
    url: endpoint + "auth/logout",
    headers: {
      "Content-Type": "application/json",
    },
    data: JSON.stringify({
      refreshToken,
    }),
  };

  try {
    const res = await axios.request(options);
    return res.data;
  } catch (error) {
    console.error("Logout revocation failed:", error);
    return {
      success: false,
      error: error?.response?.data?.error || error?.message || "Logout failed",
    };
  }
};

export const addUser = async ({
  email,
  firstname,
  lastname,
  username,
  phone,
  password,
}) => {
  
  let data = {
    email: email,
    firstname: firstname,
    lastname: lastname,
    username: username,
    phone: phone,
    password: password,
  };
  const options = {
    method: "POST",
    url: endpoint + "auth/submit",
    headers: {
      // "x-api-key": apikey,
      "Content-Type": "application/json",
    },
    data: data,
  };

  let response = {};

  try {
    const res = await axios.request(options);
    response = res.data;
  } catch (error) {
    console.error(error);
  }

  return response;
};
const TIMEFRAME_MAP = {
  yesterday: "D",
  last7Days: "W",
  last30Days: "M",
  last365Days: "Y"
};


export const fetchStrategyOwners = async () => {
  const options = {
    method: "GET",
    url: endpoint + "strategy/getstrategyowners",
    headers: {
      "X-Api-Key": apikey,
      "Content-Type": "application/json",
    },
  };

  let response = { success: false, data: [] };

  try {
    const res = await axios.request(options);
    const rawData = Array.isArray(res.data?.data) ? res.data.data
      : Array.isArray(res.data) ? res.data
      : [];

    response = {
      success: true,
      data: rawData
        .map((o) => ({
          id: o.owner ?? o.id ?? o.userId ?? o.ownerId ?? o.email ?? o.key ?? "",
          name: o.name ?? o.displayName ?? o.fullName ?? o.username ?? "",
        }))
        .filter((o) => o.id && o.name),
    };
  } catch (error) {
    response.error = true;
    response.message = error?.message || "Failed to load owners";
    console.error(error);
  }

  return response;
};

export const fetchPatsPrivateAssetTickers = async () => {
  const tokens = getAuthTokens() || {};
  const idToken = tokens.idToken;

  const options = {
    method: "GET",
    url: endpoint + "trade/pats_private_asset_tickers",
    headers: {
      "Content-Type": "application/json",
      ...(idToken ? { Authorization: `Bearer ${idToken}` } : {}),
    },
  };

  let response = { success: false, data: [] };

  try {
    const res = await axios.request(options);
    const rawData = Array.isArray(res.data?.data) ? res.data.data
      : Array.isArray(res.data) ? res.data
      : [];

    response = {
      success: true,
      data: rawData
        .map((t) => (typeof t === "string" ? t : t?.ticker ?? t?.symbol ?? ""))
        .filter(Boolean),
    };
  } catch (error) {
    response.error = true;
    response.message = error?.message || "Failed to load PATS ticker catalog";
    console.error(error);
  }

  return response;
};

export const fetchStrategiesForPeriod = async (period, page = 1, pageSize = 12, search = "", include = "owner", strategyId, ownerEmail, startDate = null, endDate = null, filters = {}) => {
  const body = period === "custom"
    ? { startDate, endDate, owner: ownerEmail, include, page, pageSize, search, strategyId }
    : { period: TIMEFRAME_MAP[period], owner: ownerEmail, include, page, pageSize, search, strategyId };

  if (filters.tags?.length) body.tags = filters.tags.filter(Boolean).join(",");
  if (filters.categories?.length) body.categories = filters.categories.filter(Boolean).join(",");
  const validOwners = (filters.owners || []).filter(Boolean);
  if (validOwners.length) body.owners = validOwners.join(",");
  if (filters.sortBy) body.sortBy = filters.sortBy;
  if (filters.sortDir) body.sortDir = filters.sortDir;

  const options = {
    method: "POST",
    url: `${endpoint}strategy/getperformanceslices`,
    headers: {
      "X-Api-Key": apikey,
      "Content-Type": "application/json",
    },
    data: JSON.stringify(body),
  };

  let response = {
    success: false,
    data: [],
    ownerStrategies: [],
    pagination: {
      page,
      pageSize,
      total: 0,
      totalPages: 1,
      hasNextPage: false,
      hasPrevPage: false,
    },
  };

  try {
    const res = await axios.request(options);
    const pagination = res.data?.pagination || {};

    response = {
      success: true,
      data: Array.isArray(res.data) ? res.data : res.data?.data || [],
      ownerStrategies: Array.isArray(res.data?.ownerStrategies) ? res.data.ownerStrategies : [],
      pagination: {
        page: pagination.page || page,
        pageSize: pagination.pageSize || pageSize,
        total: pagination.total || 0,
        totalPages: pagination.totalPages || 1,
        hasNextPage: Boolean(pagination.hasNextPage),
        hasPrevPage: Boolean(pagination.hasPrevPage),
      },
    };
  } catch (error) {
    response.error = true;
    response.message = error?.message || "Failed to load strategies";
    console.error(error);
  }

  return response;
};

export const fetchAllStrategies = async () => { // Only retrieve the name and ID of the strategies
  const options = {
    method: "GET",
    url: endpoint + "strategy/getallstrategies",
    headers: {
      "X-Api-Key": apikey,
      "Content-Type": "application/json",
    },
  };

  let response = {
    success: false,
    data: [],
    total: 0,
  };

  try {
    const res = await axios.request(options);
    response = {
      success: true,
      data: Array.isArray(res.data) ? res.data : res.data?.data || [],
      total: res.data?.total || 0,
    };
  } catch (error) {
    response.error = true;
    response.message = error?.message || "Failed to load strategies";
    console.error(error);
  }

  return response;
}

export const fetchAnnualPerformance = async (strategyId, startYear = 2023) => {
  let data = JSON.stringify({
    startYear: startYear,
  });

  const options = {
    method: "POST",
    url: `${endpoint}strategy/getannualperformancetable?strategyId=${strategyId}`,
    headers: {
      "X-Api-Key": apikey,
      "Content-Type": "application/json",
    },
    data: data,
  };

  let response = { success: false, data: null };

  try {
    const res = await axios.request(options);
    response = {
      success: true,
      data: res.data,
    };
  } catch (error) {
    response.error = true;
    response.message = error?.message || "Failed to load annual performance";
    console.error(error);
  }

  return response;
};

export const deleteStrategies = async (strategies = []) => {
  const body = { strategies };
  let data = JSON.stringify(body);

  const tokens = getAuthTokens() || {};
  const idToken = tokens.idToken;

  const options = {
    method: "POST",
    url: endpoint + "strategy/deletestrategies",
    headers: {
      "Content-Type": "application/json",
      ...(idToken ? { Authorization: `Bearer ${idToken}` } : {}),
    },
    data: data,
  };

  let response = { success: false };
  try {
    const res = await axios.request(options);
    response = res.data;
  } catch (error) {
    response.error = true;
    response.status = error?.response?.status;
    response.code = error?.response?.data?.error;
    response.message = error?.response?.data?.message || error?.message || "Failed to delete strategies";
    console.error(error);
  }

  return response;
};

export const addStrategy = async (data) => {
  const tokens = getAuthTokens() || {};
  const idToken = tokens.idToken;

  const options = {
    method: "POST",
    url: endpoint + "strategy/addstrategy",
    headers: {
      "Content-Type": "application/json",
      ...(idToken ? { Authorization: `Bearer ${idToken}` } : {}),
    },
    data: JSON.stringify(data),
  };

  let response = { success: false };
  try {
    const res = await axios.request(options);
    response = res.data;
  } catch (error) {
    response.error = true;
    response.message =
      error?.response?.data?.message ||
      error?.message ||
      "Failed to add strategy";
    console.error(error);
  }

  return response;
};

export const updateStrategy = async (strategyId, fields) => {
  const tokens = getAuthTokens() || {};
  const idToken = tokens.idToken;

  const options = {
    method: "POST",
    url: endpoint + "strategy/modifystrategy",
    headers: {
      "Content-Type": "application/json",
      ...(idToken ? { Authorization: `Bearer ${idToken}` } : {}),
    },
    data: JSON.stringify({ strategyId, ...fields }),
  };

  let response = { success: false };
  try {
    const res = await axios.request(options);
    response = res.data;
  } catch (error) {
    response.error = true;
    response.message =
      error?.response?.data?.message ||
      error?.message ||
      "Failed to update strategy";
    console.error(error);
  }

  return response;
};

export const sendTradesToPats = async (tradeIds = [], force = true) => {
  const tokens = getAuthTokens() || {};
  const idToken = tokens.idToken;

  const options = {
    method: "POST",
    url: endpoint + "trade/pats",
    headers: {
      "Content-Type": "application/json",
      ...(idToken ? { Authorization: `Bearer ${idToken}` } : {}),
    },
    data: JSON.stringify({ trades: tradeIds, force }),
  };

  let response = { success: false };
  try {
    const res = await axios.request(options);
    response = { success: true, data: res.data };
  } catch (error) {
    response.error = true;
    response.message =
      error?.response?.data?.message ||
      error?.message ||
      "Failed to send trades to PATS";
    console.error(error);
  }

  return response;
};

export const becomeAdmin = async () => {
  const tokens = getAuthTokens() || {};
  const idToken = tokens.idToken;

  const options = {
    method: "POST",
    url: endpoint + "strategy/become_admin",
    headers: {
      "Content-Type": "application/json",
      ...(idToken ? { Authorization: `Bearer ${idToken}` } : {}),
    },
  };

  let response = { success: false };
  try {
    const res = await axios.request(options);
    response = { success: true, data: res.data };
  } catch (error) {
    response.error = true;
    response.code = error?.response?.data?.error;
    response.status = error?.response?.status;
    response.message =
      error?.response?.data?.message || error?.message || "Failed to become admin";
    console.error(error);
  }

  return response;
};

export const addHistoricalSignals = async ({ strategyId, managerId, data }) => {
  const tokens = getAuthTokens() || {};
  const idToken = tokens.idToken;

  const options = {
    method: "POST",
    url: endpoint + "strategy/addhistoricalsignal",
    headers: {
      "Content-Type": "application/json",
      ...(idToken ? { Authorization: `Bearer ${idToken}` } : {}),
    },
    data: JSON.stringify({ strategyId, managerId, data }),
  };

  let response = { success: false };
  try {
    const res = await axios.request(options);
    response = res.data;
  } catch (error) {
    response.error = true;
    response.message =
      error?.response?.data?.message ||
      error?.message ||
      "Failed to upload historical signals";
    console.error(error);
  }

  return response;
};

export const fetchBackupCodes = async (accessToken) => {
  const options = {
    method: "POST",
    url: endpoint + "auth/backupcodes",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${accessToken}`,
    },
  };

  try {
    const res = await axios.request(options);
    return { success: true, data: res.data?.backupCodes };
  } catch (error) {
    console.error(error);
    return { 
      success: false, 
      message: error?.response?.data?.error || error?.message || "Failed to generate backup codes" 
    };
  }
};

export const recover2fa = async (username, backupCode) => {
  const options = {
    method: "POST",
    url: endpoint + "auth/recover2fa",
    headers: {
      "Content-Type": "application/json",
    },
    data: JSON.stringify({ username, backupCode }),
  };

  try {
    const res = await axios.request(options);
    return { success: true, message: res.data?.message };
  } catch (error) {
    console.error(error);
    return { 
      success: false, 
      message: error?.response?.data?.error || error?.message || "Failed to recover 2FA" 
    };
  }
};

export const adminReset2fa = async (email) => {
  const tokens = getAuthTokens() || {};
  const idToken = tokens.idToken;

  const options = {
    method: "POST",
    url: endpoint + "auth/adminreset2fa",
    headers: {
      "Content-Type": "application/json",
      ...(idToken ? { Authorization: `Bearer ${idToken}` } : {}),
    },
    data: JSON.stringify({ email }),
  };

  try {
    const res = await axios.request(options);
    return { success: true, message: res.data?.message };
  } catch (error) {
    console.error(error);
    throw new Error(error?.response?.data?.error || error?.message || "Failed to reset user 2FA");
  }
};
